import React from 'react'
import { Select, DatePicker, Typography } from 'antd'
import type { Dayjs } from 'dayjs'
import { TimeGranularity } from '../campaigns/PerformanceChart/types'

const { RangePicker } = DatePicker
const { Text } = Typography

interface TimeControlsProps {
  timeGranularity: TimeGranularity
  onTimeGranularityChange: (value: TimeGranularity) => void
  dateRange: [Dayjs, Dayjs]
  onDateRangeChange: (values: [Dayjs | null, Dayjs | null] | null) => void
  className?: string
}

export const TimeControls: React.FC<TimeControlsProps> = ({
  timeGranularity,
  onTimeGranularityChange,
  dateRange,
  onDateRangeChange,
  className = ''
}) => {
  return (
    <div className={`flex flex-wrap gap-4 items-end ${className}`}>
      <div className="flex-1 min-w-[200px]">
        <Text strong className="mb-2 block">Time Granularity:</Text>
        <Select
          value={timeGranularity}
          onChange={onTimeGranularityChange}
          className="w-full"
          options={[
            { label: 'Daily', value: 'day' },
            { label: 'Weekly', value: 'week' },
            { label: 'Monthly', value: 'month' }
          ]}
        />
      </div>

      <div className="flex-1 min-w-[300px]">
        <Text strong className="mb-2 block">Date Range:</Text>
        <RangePicker
          value={dateRange}
          onChange={onDateRangeChange}
          className="w-full"
          format="YYYY-MM-DD"
        />
      </div>
    </div>
  )
}
